<div data-test="wizard-product-card-container-toggle-text" class="product-card-dropdown mb-0">
  <div class="row">
    <div class="col">
      @if (toggleLabel) {
        <label [attr.for]="id" class="text--big mb-0 pt-1 text-start" translate="{{ toggleLabel }}"></label>
      }
    </div>
    <div class="col-auto">
      <div class="switch-v2">
        <input [attr.id]="id" type="checkbox" class="checkbox" (change)="onProductSelect($event.target.checked)" [checked]="isOrdered" />
        <div class="switch-v2-knob"></div>
      </div>
    </div>
  </div>
</div>
